var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Alert, ExpandableSection, IconButton } from "@brushfire/ui";
import { useDispatch, useSelector } from "react-redux";
import { clearInlineErrors } from "../../../store/AppState/actions";
var useTypedSelector = useSelector;
var InlineError = function (_a) {
    var id = _a.id, _b = _a.closeButton, closeButton = _b === void 0 ? true : _b;
    var _c = __read(useState(), 2), errorMessage = _c[0], setErrorMessage = _c[1];
    var _d = __read(useState(false), 2), show = _d[0], setShow = _d[1];
    var inlineErrors = useTypedSelector(function (store) { return store.app.inlineErrors; });
    var dispatch = useDispatch();
    useEffect(function () {
        if ((inlineErrors === null || inlineErrors === void 0 ? void 0 : inlineErrors[id]) && (!show || !errorMessage)) {
            setErrorMessage(inlineErrors[id]);
            setShow(true);
        }
        else if (errorMessage && show) {
            setShow(false);
            setTimeout(function () {
                setErrorMessage(undefined);
            }, 500);
        }
    }, [inlineErrors === null || inlineErrors === void 0 ? void 0 : inlineErrors[id]]);
    return (_jsx(ExpandableSection, __assign({ expand: show, transitionTime: 0.25 }, { children: _jsx("div", __assign({ className: "inline-error ".concat(show ? "active" : "") }, { children: _jsxs(Alert, __assign({ purpose: "danger" }, { children: [closeButton && (_jsx(IconButton, { icon: "times", classes: "f-right", ariaLabel: "Close Error", onClick: function () {
                            dispatch(clearInlineErrors());
                        } })), _jsx("div", __assign({ className: "my-1" }, { children: errorMessage !== null && errorMessage !== void 0 ? errorMessage : "" }))] })) })) })));
};
export default InlineError;
